import React, { ReactNode } from 'react';
import classnames from 'classnames';
import { Paper, Popper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  suggestionsContainer: {
    zIndex: 2
  },
  suggestionsPaper: {
    maxHeight: '50vh',
    overflowY: 'auto',
    backgroundColor: '#ffffff',
    border: '1px solid #E0E0E0',
    borderRadius: '2px',
    'box-shadow':
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
  }
});

interface Props {
  children: ReactNode;
  className?: string;
  isOpen: boolean;
  menuProps: any;
  inputEl: HTMLElement;
  classes?: any;
  suggestionsContainerProps?: any;
}

const AutocompleteSuggestionList = (props: Props) => {
  const {
    children,
    className,
    isOpen,
    menuProps,
    inputEl,
    classes: classesOverride = undefined,
    suggestionsContainerProps
  } = props;
  const classes = useStyles({ classes: classesOverride });

  return (
    <Popper
      open={isOpen}
      anchorEl={inputEl}
      placement="bottom-start"
      className={classnames(classes.suggestionsContainer, className)}
      modifiers={{}}
      {...suggestionsContainerProps}
    >
      <div {...(isOpen ? menuProps : {})}>
        <Paper
          square
          style={{
            minWidth: inputEl ? inputEl.clientWidth + 30 : null
          }}
          className={classes.suggestionsPaper}
        >
          {children}
        </Paper>
      </div>
    </Popper>
  );
};

export default AutocompleteSuggestionList;
